import { assert } from 'typia'


export type Product = {
  id: number
  name: string
  code: string | null
  code_ean: string | null
  picture: {
    small: string
  }
}
export type ProductList = Product[]

export const parseProductList = (data: Record<number, any>): ProductList => {
  const productList: ProductList = []
  for (const product of Object.values(data)) {
    productList.push(parseProduct(product))
  }
  return productList
}

const parseProduct = (product: Product): Product => {
  assert<Product>(product)
  return {
    id: product.id,
    name: product.name,
    code: product.code,
    code_ean: product.code_ean,
    picture: {
      small: product.picture.small
    }
  }
}
